import { render, staticRenderFns } from "./PageTabPanel.vue?vue&type=template&id=3f256296&"
import script from "./PageTabPanel.vue?vue&type=script&lang=js&"
export * from "./PageTabPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTabItem})
